module.exports = "/_next/static/images/casebg_2-20ef2a2d85c4241bc9cd7d4bc5437a56.png";